"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertSToMS = void 0;
var lodash_1 = require("lodash");
function convertSToMS(durationSec) {
    return (0, lodash_1.isNumber)(durationSec) && (0, lodash_1.isFinite)(durationSec)
        ? (0, lodash_1.ceil)(durationSec * 1000)
        : null;
}
exports.convertSToMS = convertSToMS;
//# sourceMappingURL=time.js.map